import $ from 'jquery';
import { FireComponent } from '@base';

export class UtilityNav extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $mainNav: document.querySelector('#bux-main-menu'),
      $mobileUtility: document.querySelector('.bux-header__utility-nav--mobile'),
      $desktopUtility: document.querySelector('.bux-header__utility-nav--desktop'),
    };
  }

  _toggleUtilityNav() {
    if (!this.elements.$mobileUtility || !this.elements.$desktopUtility) {
      return;
    }

    this.elements.$mobileUtility.setAttribute('aria-hidden', 'true');
    this.elements.$desktopUtility.setAttribute('aria-hidden', 'false');
  }

  init() {
    if (this.componentExists) {
      this._toggleUtilityNav();

      $(window).on('resize', () => {
        this._toggleUtilityNav();
      });
    }
  }
}
